<main>
  <div class="main-wrapper sign-up">
    <h1>Device enrollment</h1>
  </div>
  <!--step indicator section starts -->
  <section [attr.aria-label]="currentStep" class="step-section">
    <div class="main-wrapper">
      <app-stepindicator [stepIndicators]="stepIndicators"></app-stepindicator>
    </div>
  </section>
  <router-outlet></router-outlet>
  </main>